let selectedClubs = [];

function loadData(data) {
    console.log('Loading data:', data);

    const typeSelect = document.getElementById('club-type');
    const brandSelect = document.getElementById('brand');
    const modelSelect = document.getElementById('model');
    const ironSetOptions = document.getElementById('iron-set-options');
    const ironSetInclude = document.getElementById('iron-set-include');
    const form = document.getElementById('trade-in-form');
    const result = document.getElementById('result');
    const quantityInput = document.getElementById('quantity');
    const decreaseBtn = document.getElementById('decrease-qty');
    const increaseBtn = document.getElementById('increase-qty');

    // Quantity button handlers
    decreaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
        }
    });

    increaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue < 99) {
            quantityInput.value = currentValue + 1;
        }
    });

    // Ensure quantity stays within bounds
    quantityInput.addEventListener('input', function() {
        let value = parseInt(this.value) || 1;
        if (value < 1) this.value = 1;
        if (value > 99) this.value = 99;
    });

    // Clear existing options
    typeSelect.innerHTML = '<option value="">Select club type</option>';
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    modelSelect.innerHTML = '<option value="">Select model</option>';

    // Load club types - filter to only show types that have Mizuno products
    const mizunoTypes = [...new Set(
        data.filter(item => item.Brand === 'Mizuno')
            .map(item => item.Type)
    )].filter(type => type !== null && type !== '')
      .sort();
    
    mizunoTypes.forEach(type => {
        const option = new Option(type, type);
        typeSelect.appendChild(option);
    });

    // Set default brand to Mizuno
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    const allBrands = [...new Set(data.map(item => item.Brand))].sort();
    allBrands.forEach(brand => {
        const option = new Option(brand, brand);
        if (brand === 'Mizuno') {
            option.selected = true;
        }
        brandSelect.appendChild(option);
    });

    // Update brands when type changes
    typeSelect.addEventListener('change', function() {
        result.classList.remove('active');
        resetSteps();
        
        const selectedType = this.value;
        const brands = [...new Set(
            data.filter(item => item.Type === selectedType)
                .map(item => item.Brand)
        )].sort();
        
        brandSelect.innerHTML = '<option value="">Select brand</option>';
        let mizunoFound = false;
        brands.forEach(brand => {
            const option = new Option(brand, brand);
            if (brand === 'Mizuno') {
                option.selected = true;
                mizunoFound = true;
            }
            brandSelect.appendChild(option);
        });
        
        // Trigger brand change to load models if Mizuno was selected
        if (mizunoFound) {
            brandSelect.dispatchEvent(new Event('change'));
        } else {
            modelSelect.innerHTML = '<option value="">Select model</option>';
        }

        // Handle iron set options visibility and reset
        const ironSetOptions = document.getElementById('iron-set-options');
        const ironSetInclude = document.getElementById('iron-set-include');
        
        if (selectedType === 'Iron Set') {
            ironSetOptions.style.display = 'block';
            ironSetInclude.setAttribute('required', 'required');
        } else {
            ironSetOptions.style.display = 'none';
            ironSetInclude.removeAttribute('required');
            ironSetInclude.value = '';
        }

        // Reset missing clubs checkbox
        document.getElementById('missing-clubs').checked = false;
    });

    // Update models when brand changes
    brandSelect.addEventListener('change', function() {
        result.classList.remove('active');
        resetSteps();
        
        const selectedType = typeSelect.value;
        const selectedBrand = this.value;
        
        const models = [...new Set(
            data.filter(item => 
                item.Type === selectedType && 
                item.Brand === selectedBrand
            ).map(item => item.Model)
        )].sort();
        
        modelSelect.innerHTML = '<option value="">Select model</option>';
        models.forEach(model => {
            const option = new Option(model, model);
            modelSelect.appendChild(option);
        });
    });

    // Handle form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const club = data.find(item => 
            item.Type === typeSelect.value &&
            item.Brand === brandSelect.value &&
            item.Model === modelSelect.value
        );

        if (club) {
            const condition = document.querySelector('input[name="condition"]:checked').value;
            const quantity = parseInt(quantityInput.value) || 1;
            let baseValue = club.Price;

            // Apply 10% increase for Mizuno sales rep program
            baseValue *= 1.10;

            // Apply condition modifiers
            if (condition === 'new') {
                baseValue *= 1.10;
            } else if (condition === 'above-average') {
                baseValue *= 1.0;
            } else if (condition === 'average') {
                baseValue *= 0.9;
            } else if (condition === 'poor') {
                baseValue *= 0.8;
            }

            // Apply iron set adjustments if applicable
            if (typeSelect.value === 'Iron Set') {
                const ironSetOption = ironSetInclude.value;
                const missingClubs = document.getElementById('missing-clubs').checked;

                const ironSetMultipliers = {
                    '3-9': 0.875,
                    '3-PW': 1,
                    '3-AW': 1.1,
                    '3-SW': 1.2,
                    '3-LW': 1.2,
                    '4-9': 0.75,
                    '4-PW': 0.875,
                    '4-AW': 1,
                    '4-SW': 1.1,
                    '4-LW': 1.2,
                    '5-9': 0.50,
                    '5-PW': 0.75,
                    '5-AW': 0.875,
                    '5-SW': 1,
                    '5-LW': 1.1,
                    '6-PW': 0.50,
                    '6-AW': 0.75,
                    '6-SW': 0.875,
                    '6-LW': 1
                };

                if (ironSetMultipliers[ironSetOption]) {
                    baseValue *= ironSetMultipliers[ironSetOption];
                }

                if (missingClubs) {
                    baseValue *= 0.85;
                }
            }

            // Calculate total value with quantity
            const unitValue = baseValue;
            const totalValue = unitValue * quantity;

            updateStepProgress(2);

            result.innerHTML = `
                <div class="result-content animate-fade-in">
                    <div class="club-details">
                        <h3 class="club-name">${club.Brand} ${club.Model}</h3>
                        <p class="club-type">${club.Type}${ironSetInclude.value ? ` (${ironSetInclude.value})` : ''}</p>
                        ${quantity > 1 ? `<div class="quantity-badge">Quantity: ${quantity}</div>` : ''}
                    </div>
                    <div class="cash-value-container">
                        <div class="cash-value-display">
                            <div class="value-amount">${totalValue.toFixed(2)}</div>
                            <div class="value-label">Trade-In Value</div>
                            ${quantity > 1 ? `<p style="margin-top: 0.5rem; font-size: 0.85rem; color: #666;">${unitValue.toFixed(2)} each</p>` : ''}
                        </div>
                    </div>
                    <div class="result-buttons">
                        <button class="add-to-list-button" onclick="addClubToSelection('${club.Brand}', '${club.Model}', '${club.Type}', ${unitValue}, ${quantity}, '${ironSetInclude.value}', ${document.getElementById('missing-clubs')?.checked || false})">
                            <span>Add to Quote</span>
                            <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button class="trade-another-button" onclick="addClubAndTradeAnother('${club.Brand}', '${club.Model}', '${club.Type}', ${unitValue}, ${quantity}, '${ironSetInclude.value}', ${document.getElementById('missing-clubs')?.checked || false})">
                            <span>Add & Quote Another</span>
                            <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            `;
            result.classList.add('active');
        }
    });
}

function addClubToSelection(brand, model, type, unitValue, quantity, ironSetOption, missingClubs) {
    selectedClubs.push({
        brand,
        model,
        type,
        unitValue,
        quantity,
        ironSetOption,
        missingClubs
    });
    updateSelectedClubsList();
    updateTradeInForm();
    updateStepProgress(3);
}

function addClubAndTradeAnother(brand, model, type, unitValue, quantity, ironSetOption, missingClubs) {
    selectedClubs.push({
        brand,
        model,
        type,
        unitValue,
        quantity,
        ironSetOption,
        missingClubs
    });
    updateSelectedClubsList();
    updateTradeInForm();
    
    resetFormForNewItem();
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function resetFormForNewItem() {
    const form = document.getElementById('trade-in-form');
    form.reset();
    
    const typeSelect = document.getElementById('club-type');
    const brandSelect = document.getElementById('brand');
    const modelSelect = document.getElementById('model');
    const ironSetInclude = document.getElementById('iron-set-include');
    const quantityInput = document.getElementById('quantity');
    
    typeSelect.value = '';
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    modelSelect.innerHTML = '<option value="">Select model</option>';
    ironSetInclude.value = '';
    quantityInput.value = 1;
    
    const ironSetOptions = document.getElementById('iron-set-options');
    ironSetOptions.style.display = 'none';
    ironSetInclude.removeAttribute('required');
    
    document.getElementById('missing-clubs').checked = false;
    document.querySelector('input[name="condition"][value="average"]').checked = true;
    
    const result = document.getElementById('result');
    result.innerHTML = '';
    result.classList.remove('active');
    
    resetSteps();
    updateStepProgress(1);
}

function removeClubFromSelection(index) {
    selectedClubs.splice(index, 1);
    updateSelectedClubsList();
    updateTradeInForm();
    if (selectedClubs.length === 0) {
        resetSteps();
    }
}

function updateSelectedClubsList() {
    const selectedClubsDiv = document.getElementById('selectedClubs');
    if (selectedClubs.length > 0) {
        let totalValue = 0;
        let totalItems = 0;
        
        const clubsList = selectedClubs.map((club, index) => {
            const itemTotal = club.unitValue * club.quantity;
            totalValue += itemTotal;
            totalItems += club.quantity;
            
            return `
                <div class="selected-club-item animate-fade-in">
                    <div class="club-info">
                        <span class="club-name">${club.brand} ${club.model} ${club.type} ${club.ironSetOption ? `(${club.ironSetOption})` : ''}</span>
                        <span class="club-value">${itemTotal.toFixed(2)}</span>
                        ${club.quantity > 1 ? `<span class="club-quantity-display">Qty: ${club.quantity} × ${club.unitValue.toFixed(2)} each</span>` : ''}
                    </div>
                    <button class="remove-button" onclick="removeClubFromSelection(${index})">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            `;
        }).join('');

        selectedClubsDiv.innerHTML = `
            <div class="selected-clubs-container animate-fade-in">
                <h3 class="section-title">Trade-In Quote</h3>
                <div class="selected-clubs-list">
                    ${clubsList}
                </div>
                <div class="total-value">
                    <span class="total-label">Total Value (${totalItems} item${totalItems !== 1 ? 's' : ''}):</span>
                    <span class="total-amount">${totalValue.toFixed(2)}</span>
                </div>
                <div class="action-buttons">
                    <button class="primary-button" onclick="proceedToTradeInForm()">
                        <span>Complete Trade-In</span>
                        <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button class="secondary-button" onclick="clearSelection()">Clear Quote</button>
                </div>
            </div>
        `;
        selectedClubsDiv.style.display = 'block';
    } else {
        selectedClubsDiv.style.display = 'none';
    }
}

function updateTradeInForm() {
    let clubsList = selectedClubs.map(club => {
        const itemTotal = club.unitValue * club.quantity;
        const missingClubsText = club.missingClubs ? " (Incomplete Set)" : "";
        const qtyText = club.quantity > 1 ? ` (Qty: ${club.quantity})` : '';
        return `${club.brand} ${club.model} ${club.type} ${club.ironSetOption ? `(${club.ironSetOption}${missingClubsText})` : ''}${qtyText} - ${itemTotal.toFixed(2)}`;
    }).join(', ');

    const clubsListTextarea = document.querySelector('textarea[data-type="textarea"]');
    if (clubsListTextarea) {
        clubsListTextarea.value = clubsList;
    }
}

function clearSelection() {
    selectedClubs = [];
    updateSelectedClubsList();
    updateTradeInForm();
    resetSteps();
    document.getElementById('trade-in-form').reset();
    document.getElementById('quantity').value = 1;
    document.getElementById('result').innerHTML = '';
    document.getElementById('result').classList.remove('active');
}

function proceedToTradeInForm() {
    const formSection = document.getElementById('tradeInFormSection');
    formSection.style.display = 'block';
    formSection.scrollIntoView({ behavior: 'smooth' });
    updateTradeInForm();
}

function updateStepProgress(stepNumber) {
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, index) => {
        if (index < stepNumber) {
            step.classList.add('active');
        }
    });
}

function resetSteps() {
    const steps = document.querySelectorAll('.step');
    steps.forEach((step, index) => {
        if (index > 0) {
            step.classList.remove('active');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('Document ready');
    const dataUrl = window.GOLF_CLUBS_URL;
    console.log('Attempting to fetch from:', dataUrl);

    if (!dataUrl) {
        console.error('Golf clubs data URL not found');
        showError('Configuration error - please contact support');
        return;
    }

    fetch(dataUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(text => {
            console.log('Raw response first 100 chars:', text.substring(0, 100));
            try {
                const data = JSON.parse(text);
                if (Array.isArray(data)) {
                    console.log(`Successfully loaded ${data.length} clubs`);
                    loadData(data);
                } else {
                    throw new Error('Data is not an array');
                }
            } catch (e) {
                console.error('JSON parsing error:', e);
                throw e;
            }
        })
        .catch(error => {
            console.error('Error loading golf clubs data:', error);
            showError('Unable to load club data. Please refresh the page or try again later.');
        });
});

function showError(message) {
    const result = document.getElementById('result');
    if (result) {
        result.innerHTML = `
            <div class="error-message">
                ${message}
            </div>
        `;
    }
}